<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { InformationCircleIcon } from '@heroicons/vue/24/solid';

const page = usePage();
const errors = computed(() => page.props.errors);
const hasErrors = computed(() => Object.keys(errors.value).length > 0);
</script>

<template>
    <div
        v-show="hasErrors"
        class="bg-sunset-orange-50 text-sunset-orange-700 rounded-lg px-3 py-4"
    >
        <div class="flex items-center text-base text-inherit">
            <InformationCircleIcon
                class="size-6 text-inherit mr-1.5"
                aria-hidden="true"
            />

            Es ist ein Fehler aufgetreten.
        </div>

        <ul class="list-none text-sm mt-2">
            <li
                v-for="(error, key) in errors"
                :key
            >
                {{ error }}
            </li>
        </ul>
    </div>
</template>
